<template>
	<div class="marketingManagement-body">
		<div class="fx-header">
			<p>优惠券</p>
		</div>
		<Search @getTableData="getTableDataHandle" @getParamsData="getParamsData"></Search>
		<div class="btn-box1">
			<div style="min-height:60px;display :flex;align-items :center">
				<el-button
					type="primary"
					size="small "
					v-if="AuthorityList['08_0003_0003_00']"
					@click="addClick"
					icon="el-icon-plus"
					>新增活动优惠券
				</el-button>
				<el-button
					type="primary"
					class="search-btn fx-big-btn"
					size="small "
					v-if="AuthorityList['08_0003_0004_00']"
					@click="delClick(true)"
					plain>删除
				</el-button>
				<el-button
					type="primary"
					class="search-btn fx-big-btn"
					size="small"
					v-if="AuthorityList['08_0003_0005_00']"
					@click="stopClick"
					plain>强制结束
				</el-button>
			</div>
			<el-button
				class="search-btn fx-big-btn"
				size="small"
				v-if="AuthorityList['08_0003_0005_00']"
				@click="historyClick"
				plain>历史列表
			</el-button>
        </div>
		<div class="main-table-box">
			<el-table
			:stripe='true'
			size='mini'
			class="grid-content"
			@row-dblclick='rowClick'
			:data="tableData"
			:height="tableHeight"
			border
			@selection-change="handleSelectionChange"
			ref="table">
			<el-table-column
			type="selection"
			align="center"
			fixed="left"
			width="50">
			</el-table-column>
			<el-table-column
				prop="name"
				key="name"
				label="优惠券"
				align="center"
				min-width="200">
				<template slot-scope='scope'>
					<el-tooltip placement="top">
						<div slot="content">{{scope.row.name}}</div>
						<div class="rule-box">{{scope.row.name}}</div>
					</el-tooltip>
					<div>编号：{{scope.row.code}}</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="type"
				key="type"
				label="类型"
				align="center"
				min-width="200">
				<template slot-scope='scope'>
					<div v-if="scope.row.type === 1">满减券</div>
					<div v-if="scope.row.type === 6">商品券</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="createdate"
				key="createdate"
				label="创建时间"
				align="center"
				min-width="200">
			</el-table-column>
			<el-table-column
				prop="beginDate"
				key="beginDate"
				label="优惠内容"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<div>满{{scope.row.useconditionmoney === 0 ? "任意金额" : scope.row.useconditionmoney}}减免{{scope.row.reliefmoney}}元</div>
				</template>
			</el-table-column>
			<el-table-column
				label="适用客户"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<div>{{scope.row.attendway === 0 ? '全部客户' : '部分客户'}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="适用商品"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<div>{{scope.row.productattendway === 0 ? '全部商品' : '部分商品'}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="适用店铺"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<div>{{scope.row.shopattendway === 0 ? '全部店铺' : '部分店铺'}}</div>
				</template>
			</el-table-column>
			<el-table-column
				label="生效状态"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<div v-if="scope.row.discountstate === 1" style="color:#f0902a">未生效</div>
					<div v-if="scope.row.discountstate === 0" style="color:#64b448">进行中</div>
					<div v-if="scope.row.discountstate === 2" style="color:#4899ff">已结束</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="countcoupon"
				label="已发出"
				align="center"
				min-width="150">
			</el-table-column>
			<el-table-column
				prop="usedcoupon"
				label="已使用"
				align="center"
				min-width="150">
			</el-table-column>
			<el-table-column
				prop="usedmoney"
				label="已使用金额"
				align="center"
				min-width="150">
			</el-table-column>
			<el-table-column
				prop="totalorder"
				label="累计单量"
				align="center"
				min-width="150">
			</el-table-column>
			<el-table-column
				label="采购页显示"
				align="center"
				min-width="150">
				<template slot-scope='scope'>
					<el-switch
						:disabled="!AuthorityList['08_0003_0002_00']"
						@change="showflagChange(scope.row)"
						v-model="scope.row.showflag"
						active-color="#13ce66"
						:active-value="1"
						:inactive-value="0"
						inactive-color="#ff4949">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="操作" min-width="200" align="center">
				<template slot-scope="scope">
					<el-button  type='text' size="mini" icon="el-icon-edit" v-if="AuthorityList['08_0003_0002_00']" @click='modifyClick(scope.row)'>编辑</el-button>
					<el-button  type='text' size="mini" icon="el-icon-delete" v-if="AuthorityList['08_0003_0004_00']" @click='delClick(false,scope.row)'>删除</el-button>
				</template>
			</el-table-column>
			</el-table>
		</div>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.number"
            :page-sizes="[20, 40, 60, 100, 300]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
		<el-dialog
			title="提示"
			class="dialog-title"
			:visible.sync="showError"
			width="600px">
			<div style="width: 100%;max-height: 300px;overflow-y:auto;">
				<div style="padding: 5px 10px;text-align: left;" v-for="(item,index) in errorList" :key='index'>
					{{item}}
				</div>
				<div style="padding: 5px 10px;text-align: left;">以上优惠券不可删除，仅支持强制结束</div>
			</div>
			<div style="text-align:center" slot="footer">
				<el-button type="primary" size="mini" @click="closeError">知道了</el-button>
			</div>
		</el-dialog>
		<el-dialog
			title="历史列表"
			:visible.sync="hisModel"
			class="dialog-title"
			width="1260px"
			top="60px"
			:close-on-click-modal="false">
			<div style="height:600px;flex-direction: column;display:flex">
				<div style="margin-bottom:10px;display:flex;">
					<el-input
					style='width:200px'
						v-model="hisKeyword"
						placeholder="请输入名称/编号"
						size="mini"
						>
						<el-button style="height:28px" slot="append" icon="el-icon-search" @click="hisSearchClick"></el-button>
					</el-input>
				</div>
				<div class="main-table-box">
					<el-table
					:stripe='true'
					size='mini'
					class="grid-content"
					:data="hisTableData"
					:height="tableHeight"
					border
					ref="table">
					<el-table-column
						prop="name"
						key="name"
						label="优惠券"
						align="center"
						min-width="200">
						<template slot-scope='scope'>
							<el-tooltip placement="top">
								<div slot="content">{{scope.row.name}}</div>
								<div class="rule-box">{{scope.row.name}}</div>
							</el-tooltip>
							<div>编号：{{scope.row.code}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="type"
						key="type"
						label="类型"
						align="center"
						min-width="200">
						<template slot-scope='scope'>
							<div v-if="scope.row.type === 1">满减券</div>
							<div v-if="scope.row.type === 6">商品券</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="createdate"
						key="createdate"
						label="创建时间"
						align="center"
						min-width="200">
					</el-table-column>
					<el-table-column
						prop="beginDate"
						key="beginDate"
						label="优惠内容"
						align="center"
						min-width="150">
						<template slot-scope='scope'>
							<div>满{{scope.row.useconditionmoney === 0 ? "任意金额" : scope.row.useconditionmoney}}减免{{scope.row.reliefmoney}}元</div>
						</template>
					</el-table-column>
					<el-table-column
						label="适用客户"
						align="center"
						min-width="150">
						<template slot-scope='scope'>
							<div>{{scope.row.attendway === 0 ? '全部客户' : '部分客户'}}</div>
						</template>
					</el-table-column>
					<el-table-column
						label="适用商品"
						align="center"
						min-width="150">
						<template slot-scope='scope'>
							<div>{{scope.row.productattendway === 0 ? '全部商品' : '部分商品'}}</div>
						</template>
					</el-table-column>
					<el-table-column
						label="适用店铺"
						align="center"
						min-width="150">
						<template slot-scope='scope'>
							<div>{{scope.row.shopattendway === 0 ? '全部店铺' : '部分店铺'}}</div>
						</template>
					</el-table-column>
					<el-table-column
						label="生效状态"
						align="center"
						min-width="150">
						<template slot-scope='scope'>
							<div v-if="scope.row.discountstate === 1" style="color:#f0902a">未生效</div>
							<div v-if="scope.row.discountstate === 0" style="color:#64b448">进行中</div>
							<div v-if="scope.row.discountstate === 2" style="color:#4899ff">已结束</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="countcoupon"
						label="已发出"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="usedcoupon"
						label="已使用"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="usedmoney"
						label="已使用金额"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column
						prop="totalorder"
						label="累计单量"
						align="center"
						min-width="150">
					</el-table-column>
					<el-table-column label="操作" min-width="200" align="center">
						<template slot-scope="scope">
							<el-button  type='text' size="mini" icon="el-icon-search" v-if="AuthorityList['08_0003_0001_00']" @click='modifyClick(scope.row,true)'>查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				</div>
				<div style="width:100%;height:50px;display:flex;align-items: center;justify-content: center;">
					<el-pagination
						@size-change="hisHandleSizeChange"
						@current-change="hisHandleCurrentChange"
						:current-page="hisPage.number"
						:page-sizes="[20, 40, 60, 100, 300]"
						:page-size="hisPage.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="hisTotal">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
    </div>
</template>
<script>
import Search from '@/components/discountList/Search.vue'
export default {
	name: 'marketingManagement',
	components: {
		Search
	},
	data () {
		return {
			hisModel: false,
			AuthorityList: {
				'08_0003_0001_00': false,
				'08_0003_0002_00': false,
				'08_0003_0003_00': false,
				'08_0003_0004_00': false,
				'08_0003_0005_00': false
			},
			discountState: -1,
			keyword: '',
			tableData: [],
			tableHeight: '100%',
			total: 0,
			ids: [],
			page: {
				number: 1,
				size: 20
			},
			hisTableData: [],
			hisTotal: 0,
			hisPage: {
				number: 1,
				size: 20
			},
			hisKeyword: '',
			showError: false,
			errorList: [],
			type: -1
		}
	},
	created () {
		this.tableReload()
		this.getAuthority('08_0003_0000_00')
	},
	methods: {
		closeError () {
			this.showError = false
		},
		delClick (flag, row) {
			if (flag) {
				if (this.ids.length === 0) {
					this.$message.error('至少选则一条活动')
					return false
				}
			}
			let list = this.ids.map(item => {
				return item.id
			})
			let name = ''
			if (flag) {
				let arr = []
				this.ids.forEach(item => {
					let name = (item.type === 1 ? '满减券' : '商品券') + item.name + `满${item.useconditionmoney}减免${item.reliefmoney}元`
					arr.push(name)
				})
				name = arr.join(',')
			} else {
				name = name = (row.type === 1 ? '满减券' : '商品券') + row.name + `满${row.useconditionmoney}减免${row.reliefmoney}元`
			}
			let message = '删除：' + name
			let loggerMessage = message
			let loggerUrl = window.location.href.split('?')[0]
			loggerUrl = loggerUrl.replace(window.location.origin, '').substring(1)
			let params = {
				discountids: flag ? list.join(',') : row.id,
				type: 1
			}
			params.logMessage = {
				message: loggerMessage,
				referer: loggerUrl
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/delete`,
				data: params
			}).then(res => {
				if (!res.result) {
					this.errorList = []
					this.errorList = res.data
					this.showError = true
					return false
				} else {
					this.$message.success('删除成功！')
					this.tableReload()
				}
			})
		},
		historyClick () {
			this.hisModel = true
			this.hisKeyword = ''
			this.hisPage.number = 1
			this.hisPage.size = 20
			this.hisSearch()
		},
		hisSearchClick () {
			this.hisPage.number = 1
			this.hisPage.size = 20
			this.hisSearch()
		},
		hisSearch () {
			let params = {
				discountState: -1,
				keyword: this.hisKeyword,
				page: this.hisPage.number,
				size: this.hisPage.size,
				historyflag: 1,
				type: -1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/coupon/list`,
				data: params
			}).then(res => {
				this.hisTableData = res.recordList
				this.hisTotal = res.recordCount
			})
		},
		showflagChange (row) {
			let params = {
				id: row.id,
				showflag: row.showflag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/coupon/update/showflag`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功！')
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		stopClick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择数据！')
				return false
			}
			this.$confirm('强制结束后，客户的优惠券将失效，无法使用！且从客户优惠券账户里删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.stopHandler()
			}).catch(() => {
			})
		},
		stopHandler () {
			let ids = this.ids.map(item => {
				return item.id
			})
			let name = ''
			let arr = []
			this.ids.forEach(item => {
				console.log(item)
				let name = (item.type === 1 ? '满减券' : '商品券') + item.name + `满${item.useconditionmoney}减免${item.reliefmoney}元`
				arr.push(name)
			})
			name = arr.join(',')
			let message = '强制结束：' + name
			let loggerMessage = message
			let loggerUrl = window.location.href.split('?')[0]
			loggerUrl = loggerUrl.replace(window.location.origin, '').substring(1)
			let params = {
				discountids: ids.join(',')
			}
			params.logMessage = {
				message: loggerMessage,
				referer: loggerUrl
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/coupon/forcedend`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功！')
					this.tableReload()
				}
			})
		},
		handleSelectionChange (val) {
			this.ids = val
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		addClick () {
			window.sessionStorage.removeItem('discountId')
			window.sessionStorage.removeItem('discountHistory')
			this.$router.push('discountDetail')
		},
		rowClick (row, column, event) {
			this.modifyClick(row)
		},
		modifyClick (row, flag) {
			if (flag) {
				window.sessionStorage.setItem('discountHistory', true)
			} else {
				window.sessionStorage.removeItem('discountHistory')
			}
			window.sessionStorage.setItem('discountId', row.id)
			this.$router.push('discountDetail')
		},
		getTableDataHandle (data) {
			this.tableData = data.recordList
			this.total = data.recordCount
		},
		getParamsData (data) {
			this.page.number = data.page
			this.page.size = data.size
			this.discountState = data.discountState
			this.keyword = data.keyword
			this.type = data.type
		},

		tableReload () {
			let params = {
				discountState: this.discountState,
				keyword: this.keyword,
				page: this.page.number,
				size: this.page.size,
				type: this.type
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/coupon/list`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.total = res.recordCount
			})
		},
		hisHandleSizeChange  (val) {
			this.hisPage.size = val
			this.hisSearch()
		},
		hisHandleCurrentChange (val) {
			this.hisPage.number = val
			this.hisSearch()
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.marketingManagement-body{
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow-y :auto;
    padding-bottom :50px;
    border-radius :0px 0px 10px 10px;
	.btn-box1{
		justify-content: space-between;
		display: flex;
		align-items: center
	}
	.main-table-box {
		flex: 1
		padding-bottom 10px
		overflow-y: auto;
	}
	.rule-box{
		width:100%;
		text-align:center;
		padding: 0 10px;
		overflow :hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.point{
		width:6px;
		height:6px;
		border-radius:50%;
		margin-right:10px;
	}
	.point-box{
		display :flex;
		align-items:center;
		justify-content :center
	}
}

</style>
<style lang="stylus">
.marketingManagement-body {
	.cell{
		padding :0px !important
	}
	.detail-dialog-title {
		.el-dialog__header {
			display: none
		}
		.el-dialog__title {
			padding-left 10px;
			border: none !important;
		}
	}
	.showPicDialog{
		.el-dialog__header {
			border-bottom:1px solid #eee;
			padding: 20px 0px 10px;
			text-align: left;
		}
	}
	.customerDialog{
		.el-dialog__header {
			margin :0px 20px;
			padding :10px 0px;
			border-bottom:1px solid #eee;
			text-align: left;
		}
		.el-dialog__body{
			padding: 10px 20px 10px 20px;
		}
		.name-input .el-input-group__append{
			background-color:var(--fx-primary-color);
			color:#FFFFFF
		}
	}
	.subordinateDialog{
		.el-dialog__body{
			padding :0px 20px;
		}
		.el-dialog__header {
			display :none
		}
		.blue-line{
			height :20px;
			width: 5px;
			background-color :var(--fx-primary-color);
			margin-right :10px;
		}
		.title{
			font-size:16px;
			justify-content: space-between;
			font-weight: bold;
			display :flex;
			flex-direction :row;
			border-bottom:1px solid #eee;
			padding: 20px 0px 10px;
			text-align: left;
			margin-bottom :5px;
			.close{
				cursor: pointer;
				width: 20px;
				height: 20px;
				display :flex;
				align-items :center;
				justify-content :center;
				color :white;
				border-radius: 50%;
				background-color: #f00;
				line-height: 21px;
				font-weight: bold;
			}
		}
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.alert-dialog{
		.el-dialog__title {
			padding-left 10px;
			border: none !important;
			float : left !important;
		}
		.el-dialog__body{
			padding:20px 20px 20px 20px
		}
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: #FFFFFF !important;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:black !important;
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}


}
</style>
